import script from "./DigitalWorkerActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalWorkerActivity.vue?vue&type=script&setup=true&lang=js"

import "./DigitalWorkerActivity.vue?vue&type=style&index=0&id=332f66b0&scoped=true&lang=css"
import "./DigitalWorkerActivity.vue?vue&type=style&index=1&id=332f66b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332f66b0"]])

export default __exports__